import { render, staticRenderFns } from "./SaccSarrPage.vue?vue&type=template&id=3bd52940"
import script from "./SaccSarrPage.vue?vue&type=script&lang=js"
export * from "./SaccSarrPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports